import Hero from '../components/company/hero';
import FounderNote from '../components/company/founder-note';
import Mission from '../components/company/mission';
import Loop from '../components/company/loop';
import Products from '../components/company/products';

const Home = () => {
    return (
        <>
            <Hero />
            <FounderNote />
            <Mission />
            <Loop />
            <Products />
        </>
    );
};

export default Home;
